/** True when the UI is served by local-hub (offline mode) on port 9102. */
export function isLocalHubRuntime() {
  if (typeof window === 'undefined') return false;
  return String(window.location.port || '') === '9102';
}

/** Sidebar tabs shown in local-hub offline mode (restaurant admin). */
export const LOCAL_HUB_RESTAURANT_PATHS = [
  '/restaurant/pos',
  '/restaurant/kds',
  '/restaurant/bills',
  '/restaurant/tables',
  '/restaurant/settings',
];

/** Sidebar tabs shown in local-hub offline mode (staff). */
export const LOCAL_HUB_STAFF_PATHS = [
  '/staff/orders',
  '/staff/kds',
];

export function getLocalHubHomePath(role) {
  if (role === 'staff') return '/staff/orders';
  return '/restaurant/pos';
}

export function filterLocalHubMenuItems(items, allowedPaths) {
  const allowed = new Set(allowedPaths);
  return (items || []).filter((item) => allowed.has(item.path));
}
